<div *ngIf="invalidInner && countRemaining > 0 && !validateSequence" class="error-message" [class.small]="!isLarge">
  <ng-container *ngIf="!alibiError">
    Invalid PIN number. {{countRemaining}} attempts left.
  </ng-container>
  <ng-container *ngIf="alibiError">
    Must enter a different PIN.
  </ng-container>
</div>

<div *ngIf="countRemaining === 0" class="error-message" [class.small]="!isLarge">
  {{errorPinCountMessage}}
</div>

<div *ngIf="sequenceInvalid" class="error-message" [class.small]="!isLarge">
  {{sequenceMessage}}
</div>

<div class="pin-container" [ngClass]="{'large': isLarge, 'invalid': invalid}">
  <input *ngFor="let input of pinInputs; let i = index; let last = last"
         autocomplete="new-password"
         name="pin-input-{{i}}"
         [type]="inputsType"
         #pinInput
         [value]="input"
         [class.last]="last"
         [maxLength]="1"
         [disabled]="disabled"
         (keydown)="valueInput($event, i)"
         [tabIndex]="1"
  />
</div>
